<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    @if (isLoadingUsersList && !isLoaderHiddenWhenLoadUsersList) {
        <sb-loader></sb-loader>
    }
    @if (!(isLoadingUsersList && !isLoaderHiddenWhenLoadUsersList)) {
        <div class="assign-block d-flex flex-row align-items-center">
            <div
                class="assign-block-btn form-control pointer d-flex flex-row align-items-center"
                tooltip="{{
                    isShowAssigningSelect ? null : assignee ? null : ('Assign ticket to a team member' | translate)
                }}"
                container="body"
                placement="bottom">
                <div class="assign-block-image">
                    <button id="lockTicketButton" class="btn btn-locked btn-icon" [hidden]="assignee">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Unlockd icon.svg'">
                        </sb-inline-svg>
                    </button>
                    <sb-user-avatar
                        class="user-avatar-btn"
                        [hidden]="!assignee"
                        [user]="assignee"
                        [isNeedTooltip]="false"
                        [size]="'btn'">
                    </sb-user-avatar>
                </div>
                <div class="assign-block-content">
                    @if (!isShowAssigningSelect) {
                        <div class="assign-block-text" (click)="showAssigningSelect($event)">
                            <div class="truncate" style="max-width: 300px; padding: 0.375rem 30px 0.375rem 0.375rem">
                                @if (assignee) {
                                    @if (isAssignedToCurrentUser) {
                                        <span>{{ 'Assigned to me' | translate }}</span>
                                    } @else {
                                        <span>
                                            {{ 'Assigned to ' | translate }} {{ assignee.name || assignee.email }}
                                        </span>
                                    }
                                } @else {
                                    <span>{{ 'Unassigned' | translate }}</span>
                                }
                            </div>

                            @if (assignee) {
                                <sb-inline-svg
                                    class="icon icon-close"
                                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"
                                    (click)="$event.stopPropagation(); unassign()">
                                </sb-inline-svg>
                            }
                        </div>
                    } @else {
                        @if (isLoadingUsersList) {
                            <sb-loader></sb-loader>
                        } @else {
                            <div
                                class="assign-block-editor w-100"
                                (appClickOutsideAssignBlock)="closeAssigningSelect()">
                                <ng-select
                                    [items]="usersToAssign"
                                    bindLabel="label"
                                    id="form-element-{{ formField.id }}"
                                    name="formField{{ formField.id }}"
                                    #ngSelect
                                    [virtualScroll]="true"
                                    [(ngModel)]="assignee"
                                    placeholder="{{ 'Name or email' | translate }}"
                                    (change)="onUpdateAssignee(); closeAssigningSelect()">
                                    <ng-template ng-label-tmp let-item="item">
                                        <div
                                            class="d-flex truncate tag-locked assign-block d-flex flex-row align-items-center">
                                            {{ item.name }}
                                        </div>
                                    </ng-template>
                                    <ng-template
                                        ng-option-tmp
                                        let-item="item"
                                        let-index="index"
                                        let-search="searchTerm">
                                        <div class="d-flex align-items-center mt-1 mb-1">
                                            @if (item.isSelected) {
                                                <sb-inline-svg
                                                    class="icon check-icon me-2"
                                                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'">
                                                </sb-inline-svg>
                                            } @else {
                                                <sb-user-avatar
                                                    class="user-avatar-btn"
                                                    [user]="item"
                                                    [size]="'btn'"
                                                    [isNeedTooltip]="false">
                                                </sb-user-avatar>
                                            }

                                            <div class="truncate">
                                                <div class="truncate text-light">
                                                    <span class="truncate-name">
                                                        {{ item.name | truncate: 23 }}
                                                    </span>
                                                    <small class="text-light"> {{ item.email }} </small>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    }
</div>
